// extracted by mini-css-extract-plugin
export default {"p_bg":"PharmacyInsurance_p_bg__RKtF+","p_header":"PharmacyInsurance_p_header__fbNfS","p_cont":"PharmacyInsurance_p_cont__A96Sm"};